import { Route, Routes, useLocation } from "react-router-dom";
import "./assets/css/main.css";
import "./App.css"

//Components
import Header from "./component/header/Header";
import Footer from "./component/footer/Footer";
import NotFound from "./component/404/Not";

//Pages
import Home from "./page/Home";
import Dapp from "./page/Dapp";

function App() {
  const location = useLocation();

  return (
    <>
      {location.pathname === "/" ||
      location.pathname === "/app" 
      // || location.pathname === "/login" ||
      // location.pathname === "/register"
       ? (
        <>
          {/* 
          <div className="preloader">
            <div className="preloader-container">
              <span className="animated-preloader" />
            </div>
          </div>
          */}
     

          <div className="full-wh">
            <div className="bg-animation">
              <div id="stars" />
              <div id="stars2" />
              <div id="stars3" />
              <div id="stars4" />
            </div>
          </div> 
        
          <div style={{width:'auto !important'}} className="page-wrapper">
                
                {location.pathname === "/login" ||
                location.pathname === "/register" ? (
                  ""
                ) : (
                  <Header />
                )}
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/app" element={<Dapp />} />
                </Routes>
                {location.pathname === "/login" ||
                location.pathname === "/register" ? (
                  ""
                ) : (
                  <Footer />
                )}
          </div>
        </>
      ) : (
        <NotFound />
      )}
    </>
  );
}

export default App;
